import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  LOGOUT,
  VALIDATE_CONCURRENT_LOGIN_SUCCESS,
  VALIDATE_CONCURRENT_LOGIN_FAIL,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
} from "../Actions/types";

import Cookies from 'js-cookie';

const token = Cookies.get("JWToken");

const initialState = token
  ? { isLoggedIn: true }
  : { isLoggedIn: false };

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        token: payload.token,
        mobile: payload.mobile,
        email: payload.email,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
      };
    case VALIDATE_CONCURRENT_LOGIN_SUCCESS:
      return {
        ...state,
        isUniqueLogin: payload.isUniqueLogin,
      };
    case VALIDATE_CONCURRENT_LOGIN_FAIL:
      return {
        ...state,
        isUniqueLogin: false,
      };
    case GET_USER_SUCCESS: 
      return {
        ...state,
        user: payload.user,
        haveData: true
      }
    case GET_USER_FAIL:
      return {
        ...state,
        haveData: false
      }
    default:
      return state;
  }
}
